import { classnames } from 'Utils/classnames/classnames.utils';
import React from 'react';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './ProductLogo.theme';
type Props = {
  className?: string;
  isExclusiveCollection?: boolean;
  iconName: IconName;
  productCountry?: string;
  productName?: string;
  theme?: keyof typeof themes;
};
export const ProductLogo = ({
  className,
  isExclusiveCollection,
  iconName,
  productCountry,
  productName,
  theme = 'default',
}: Props) => {
  const {
    thIcon,
    thIconWidth,
    thRoot,
    thIsNotSquare,
    thProductInfo,
    thProductName,
    thProductCountry,
  } = themes[theme]({
    isExclusiveCollection,
  });
  return (
    <div className={classnames(thRoot, className)}>
      <Icon
        alt={productName}
        className={thIcon}
        isNotSquare={thIsNotSquare}
        name={iconName}
        width={thIconWidth}
      />
      <div className={thProductInfo}>
        {productName && (
          <p className={thProductName} data-testid="product-logo-name">
            {productName}
          </p>
        )}
        {productCountry && (
          <p className={thProductCountry} data-testid="product-logo-country">
            {productCountry}
          </p>
        )}
      </div>
    </div>
  );
};
